import { useQuery } from '@tanstack/react-query';

import { GatewayPricingPlan } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/gateway-pricing-plan/:planId/`;

type QueryFnType = typeof queryFn;
interface DTO {
    planId: string;
    parkingId: string;
}
const queryFn = ({ planId, parkingId }: DTO): Promise<GatewayPricingPlan> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetGatewayPricingPlans };
